import { Component, OnInit, OnDestroy } from '@angular/core';
import { MenuService } from '../../../services/menu.service';
import { DataIoService } from '../../../services/data-io.service';
import { IconBarService } from '../../../services/icon-bar.service';
import { MenuNode } from '../../../classes/MenuNode';
import { TimeFrame } from '../../../classes/TimeFrame';
import { Helper } from '../../../classes/Helper';
import { TimeFrameManager } from '../../../classes/TimeFrameManager';
import { BaseSensor } from '../../../classes/BaseSensor';

@Component({
  selector: 'app-zeitprogramm',
  templateUrl: './zeitprogramm.component.html',
  styleUrls: ['./zeitprogramm.component.scss']
})
export class ZeitprogrammComponent implements OnInit, OnDestroy {


	constructor(
		private menuService:MenuService,
		private ioService:DataIoService,
		private iconbar:IconBarService
	) {
		
	}
	// vst = vorlaufsolltemperatur
	_steps=['loading','vst_in_window','vst_out_of_window','day_1','day_2','day_3','day_4','day_5','day_6','day_7','vst_absence','absence'];
	_step = 'loading';
	_smallLetters:string="";
	_bigLetters:string="";
	_unit:string="";

	s():string{
		
		return this._smallLetters;

	}
	b():string{
		
		return this._bigLetters;

	}

	unit():string{

		return this._unit;

	}
	_hasScale:boolean = false;
	hasScale():boolean{
		return this._hasScale;

	}
	increaseTime(date){
		let hours = date.getHours();
		let minutes = date.getMinutes();

		if(hours == 23 && minutes == 59){
			return;
		}
		if(minutes == 50 && hours < 23){
			date.setHours(++hours);
			date.setMinutes(0);
		}
		if(minutes == 50 && hours == 23){
			date.setMinutes(59);
			return;
		}
		date.setMinutes(minutes+10);
		return;
	}

	decreaseTime(date){
		let hours = date.getHours();
		let minutes = date.getMinutes();
		if(hours == 0 && minutes == 0){
			return;	
		}
		
		if(hours == 23 && minutes == 59){
			date.setMinutes(50);
			return;
		}
		if(minutes == 0){
			date.setHours(--hours);
			date.setMinutes(50);
			return;
		}
		date.setMinutes(minutes -10);
	}
	getFirstFreeSlot(after?:Date){

		let date = new Date();
		date.setHours(0);
		date.setMinutes(0);
		date.setSeconds(0);
		
		let last = false;
		if(after){
			date = new Date(after.getTime());
			this.increaseTime(date)
			/*
			date = new Date(after.getTime());
			if(date.getHours() == 23 && date.getMinutes() == 30){
				date.setMinutes(59);
				last = true;
			}else{
				if(date.getMinutes() == 30){
					date.setMinutes(0);
					date.setHours(date.getHours()+1);
				}else{
					date.setMinutes(30);
				}
			}
			*/

		}
		if(last){
			return undefined;
		}
		let contains = true;
		while(contains){
			this.increaseTime(date)
			contains = false;
			for(let frame of this.currentTimeFrameManager.getTimeFrames(this.getCurrentDay())){
				if(frame.contains(date)){
					contains = true;
				}
			}
			if(!contains){
				return date;
			}
			if(last){
				return undefined;
			}
		}
		//console.log("No empty timeslot found.");
		return undefined;
	}
	
	_newFrame = false;

	nextFrame(){
		if(this._newFrame){
			let f = this.currentTimeFrameManager.getTimeFrames(this.getCurrentDay())[this.frameNumber];
			let end:Date = this.getFirstFreeSlot(f.getBegin());
			if(end){
				f.setEnd(end);
			}
		}
		this._newFrame = false;
		if(this.frameStep == 'begin'){
			this.frameStep = 'end';
			return;
		}else{	
			this.frameStep = 'begin';
		}
		if(this.frameNumber < 3){
			if(this.currentTimeFrameManager.getTimeFrames(this.getCurrentDay()).length > this.frameNumber){
				let timeframe = new TimeFrame();
				
				let begin:Date = this.getFirstFreeSlot();
				let end:Date = this.getFirstFreeSlot();
				if(begin != undefined && end != undefined){
					timeframe.setBegin(begin);
					timeframe.setEnd(end);
					timeframe.setDay(this.getCurrentDay());

					console.log("Adding new timeframe from "+timeframe.getBegin());
					this.currentTimeFrameManager.addTimeFrame(timeframe);
					this._newFrame = true;
				}else{
					console.log("Not adding new timeframe.");
					return;
				}
				
			}else{
				this._newFrame = false;
			}
			this.frameNumber++;
		}else{
			this.frameNumber = 0;
		}

	}
	previousFrame(){
		this._newFrame = false;
		if(this.frameStep == 'end'){
			this.frameStep = 'begin';
			return;
		}else{
			this.frameStep = 'end';
		}
		
		if(this.frameNumber > 0){
			this.frameNumber--;
		}	
	}
	currentTimeFrameManager:TimeFrameManager=undefined;
	
	frameNumber = 0;
	frameStep:string='begin';
	_scaleElements:Array<number>;

	scaleType():string{

		return 'timeline';

	}

	getScaleElements():Array<number>{

		if(!this.hasScale()){
			return undefined;
		}
		return this._scaleElements;
	}	
	
	init():void{

	}
	getCurrentDay(){
		
		switch(this._step){
			case 'day_1':{
				return 0;
			}
			case 'day_2':{
				return 1;
			}
			case 'day_3':{
				return 2;
			}
			case 'day_4':{
				return 3;
			}
			case 'day_5':{
				return 4;
			}
			case 'day_6':{
				return 5;
			}
			case 'day_7':{
				return 6;
			}
		}
		return undefined;
	}

	eventSubscription : any = undefined;
	sensor:BaseSensor = undefined;
	updateUI(){
		this._bigLetters = '';
		this._smallLetters = '';
		this._unit = '';
		this._hasScale = false;
		this.menuService.undisableButton('up');
		this.menuService.undisableButton('down');
		this.menuService.undisableButton('slider');
		this._scaleElements = undefined;
		switch(this._step){
			case 'vst_in_window':{
				this._smallLetters = "1 \u0304 \u0304 \u0304";
				this._bigLetters = this.sensor.getCurrentValue()+"";
				this._unit = this.sensor.getRawUnit();
				return;
			}
			case 'vst_out_of_window':{
				this._smallLetters = "1 ---";
				this.menuService.disableButton('up');
				this.menuService.disableButton('down');
				this.menuService.disableButton('confirm');
				this.menuService.disableButton('slider');
				this._bigLetters = 'oFF'
				this._unit = '';
				return;
			}
			case 'day_1':
			case 'day_2':
			case 'day_3':
			case 'day_4':
			case 'day_5':
			case 'day_6':
			case 'day_7':{
				let day = this.getCurrentDay();
				this._smallLetters = (day+1)+"";
				this._hasScale = true;
				this._scaleElements = this.currentTimeFrameManager.getScale(day,48);
				//console.log("getting frame "+this.frameNumber);
				let f:TimeFrame = this.currentTimeFrameManager.getTimeFrames(this.getCurrentDay())[this.frameNumber];
				let blinkElement = Math.round( this.percentageOfDay( ((this.frameStep=='begin')?f.getBegin():f.getEnd()) )*48 );
				//console.log("Blinking "+blinkElement +" for "+f.getBegin());
				let frame = this.currentTimeFrameManager.getTimeFrames(this.getCurrentDay())[this.frameNumber];
				let time = undefined;
				
				if(this.frameStep == 'begin'){
					time = frame.getBegin();
				}else{
					time = frame.getEnd();
				}
				this._bigLetters = time.getHours()+":"+Helper.twoDigits(time.getMinutes());
				if(this._bigLetters == '23:59'){
					this._bigLetters = '24:00';
				}
				this._scaleElements[blinkElement]=2;

				return;
			}
			case 'vst_absence':{
				this._smallLetters = "1 ___";
				this._unit = this.sensor.getRawUnit();
				this._bigLetters = this.sensor.getCurrentValue()+"";
				this.menuService.disableButton('up');
				this.menuService.disableButton('down');
				this.menuService.disableButton('slider');
				return;
			}
			case 'absence':{
				this._smallLetters = "1 ___";
				this.menuService.disableButton('menu');
				this._bigLetters = this.sensor.getCurrentElement();
				return;
			}
		}
	}
	percentageOfDay(date:Date):number{
		return (date.getHours()/24) + (1/24)*(date.getMinutes()/60);
	}
	increaseSensorValue(){
		this.sensor.increase();
	}


	decreaseSensorValue(){
		this.sensor.decrease();	
	}


	timeIncrease(){
		let frame = this.currentTimeFrameManager.getTimeFrames(this.getCurrentDay())[this.frameNumber];
		let time = undefined;
		
		if(this.frameStep == 'begin'){
			time = new Date(frame.getBegin().getTime());
		}else{
			time = new Date(frame.getEnd().getTime());
		}
		this.increaseTime(time);
		if(frame.toNumber(time) >= frame.toNumber(frame.getEnd()) && this.frameStep == 'begin' && !this._newFrame){
			return;
		}
		if(this.collides(time,frame) && this.frameStep == 'begin'){
			this.menuService.disableButton('confirm');
		}
		if(this.frameStep == 'begin'){
			frame.setBegin(time);
		}else{
			frame.setEnd(time);
		}
	}

	collides(date,_frame):boolean{
		for(let frame of this.currentTimeFrameManager.getTimeFrames(this.getCurrentDay())){
			if(_frame != frame && frame.containsStrict(date)){
				return true;
			}
		}
		return false;
		
	}
	timeDecrease(){
		//console.log("time increase.");
		let frame = this.currentTimeFrameManager.getTimeFrames(this.getCurrentDay())[this.frameNumber];
		let time = undefined;

		if(this.frameStep == 'begin'){
			time = new Date(frame.getBegin().getTime());
		}else{
			time = new Date(frame.getEnd().getTime());
		}
		this.decreaseTime(time);
		if(frame.toNumber(time) <= frame.toNumber(frame.getBegin()) && this.frameStep == 'end'){
			return;
		}
		if(this.collides(time,frame) && this.frameStep == 'begin'){
			this.menuService.disableButton('confirm');
		}
		/*
		if(frame.toNumber(time) < frame.toNumber(frame.getBegin())|| frame.toNumber(time) < frame.toNumber(frame.getEnd())){
			return;
		}
		if(this.collides(time,frame)){
			if(this.frameStep == 'begin'){
				this.menuService.disableButton('confirm');
				frame.setBegin(time);
			}
		}
		*/
		if(this.frameStep == 'begin'){
			frame.setBegin(time);
		}else{
			frame.setEnd(time);
		}
	}


	up(){
		switch(this._step){
			case 'vst_in_window':
			case 'vst_absence':
			case 'absence':{
				this.increaseSensorValue();		
				return;
			}
			case 'day_1':
			case 'day_2':
			case 'day_3':
			case 'day_4':
			case 'day_5':
			case 'day_6':
			case 'day_7':{
				this.timeIncrease();
				return;
			}
			case 'vst_out_of_window':
			{
				return;
			}
		}
	}


	down(){
		switch(this._step){
			case 'vst_in_window':
			case 'absence':
			case 'vst_absence':{
				this.decreaseSensorValue();
				return;
			}
			case 'day_1':
			case 'day_2':
			case 'day_3':
			case 'day_4':
			case 'day_5':
			case 'day_6':
			case 'day_7':{
				this.timeDecrease();
				return;
			}
			case 'vst_out_of_window':
			{
				return;
			}
		}
	}

	updateStep(){
		let hc = this.ioService.getDeviceInfo().getDefaultHeatingCircuit();
		switch(this._step){
			case 'vst_in_window':{
				this.sensor = hc.getScale('vorlaufsolltemp_wunsch');
				return;
			}

			case 'absence':{
				this.sensor = this.ioService.deviceInfo().getScale('absence');
				//this.sensor = this.ioService.deviceInfo().getScale('absence_temperature_zeitprogramm');
				this.sensor.setCurrentValue(0);
				return;
			}
			case 'day_1':
			case 'day_2':
			case 'day_3':
			case 'day_4':
			case 'day_5':
			case 'day_6':
			case 'day_7':{
				return;
			}
			case 'vst_out_of_window':{
				//this.sensor = hc.getScale('vorlaufsolltemp_absenkwunsch');
				this.sensor = this.ioService.deviceInfo().getScale('absence_temperature_zeitprogramm');
				return;
			}
			case 'vst_absence':{
				this.sensor = this.ioService.deviceInfo().getScale('absence_temperature');

				return;
			}
		}
	}

	nextStep(){
		let idx = this._steps.indexOf(this._step);
		idx++;
		if(idx >= this._steps.length){
			this.ioService.deviceInfo().getDefaultZone().setTimeFrameManager('heating',this.currentTimeFrameManager);
			this.menuService.goto('dashboard');
			return;
		}
		this._step = this._steps[idx];
		//console.log("Step now: "+this._step);
		let day = this.getCurrentDay();
		//console.log("Day: "+day);
		if(day != undefined){

			this.frameNumber = 0;
			
		}

		
		this.updateStep();
		this.updateUI();
		
	}

	previousStep(){
		let idx = this._steps.indexOf(this._step);
		if(idx <= 1){
			this.menuService.goto('dashboard');
			return;
		}
		idx--;

		this._step = this._steps[idx];
		//console.log("Step now: "+this._step);

		let day = this.getCurrentDay();
		if(day != undefined){
			this.frameNumber = 0;
			
		}
		
		this.updateStep();
		this.updateUI();
	}

	ngOnInit() {
		console.error('Init on Zeitprogramm');
		this.init();
		this._step = 'loading';
		setTimeout( ()=>{
			//console.log("Not loading anymore?");
			this.nextStep();
		},500);
		this.menuService.buttonEnabled('menu');
		this.iconbar.saveState('zeitprogramm');
		this.iconbar.disable();
		this.currentTimeFrameManager = this.ioService.deviceInfo().getDefaultZone().getTimeFrameManager('heating').copy();
		this.unsubscribe();
		this.eventSubscription = this.ioService.inputs.events$.subscribe( 
			(evt) => {

				console.warn("Event: "+evt+ " on Zeitprogramm");
				this.menuService.undisableButton('confirm');
				if(evt == 'up'){
					this.up();
					this.updateUI();
					return;
				}

				if(evt == 'down'){
					this.down();
					this.updateUI();
					return;
				}

				if(evt == 'back'){
					let day = this.getCurrentDay();
					if( day != undefined && (this.frameStep != 'begin' || this.frameNumber > 0) ){
						this.previousFrame();
						this.updateUI();
						return;
					}
					this.previousStep();
					return;
				}


				if(evt == 'menu'){
					this.nextStep();
					return;
				}

				if(evt == 'confirm'){
					if(this._step == 'absence'){
						this.nextStep();
						return;
					}
					let day = this.getCurrentDay();
					if(day != undefined){
						this.nextFrame();
					}
					if(this._step == 'absence'){
						this.menuService.goto('dashboard');
						return;
					}
					this.updateUI();

					return;
				}
			}
		);
	}

	unsubscribe(){
		if(this.eventSubscription != undefined){
			console.warn("Unsubscribing zeitprogramm.");
			this.eventSubscription.unsubscribe();
			this.eventSubscription = undefined;
		}
	}
	ngOnDestroy(){
		console.warn("Destroying zeitprogramm.");
		this.unsubscribe();
		
		this.iconbar.enable();
		this.iconbar.restoreState('zeitprogramm');
	}
}
